var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jst-erp-scene" },
    [
      _c("StepPlayer", {
        ref: "player",
        attrs: {
          steps: _vm.scenario.steps,
          "initial-step-id": _vm.scenario.initialStepId,
          "initial-form": _vm.scenario.initialForm,
          "initial-ui": _vm.scenario.initialUi,
          "show-tip": false
        },
        on: {
          "step-change": _vm.onStepChange,
          "guard-failed": _vm.onGuardFailed,
          finish: _vm.onFinish
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06264f63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06264f63","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/jushuitan/JstErpCreateAftersaleScene.vue
// module id = 1373
// module chunks = 0